import React from "react";
import LayoutMain from "../../layouts/LayoutMain";
import LayoutBasic from "../../layouts/LayoutBasic";
import HomePage from "../../modules/Overview";

const Home = () => {
  return (
    <div >
    <LayoutBasic>
      <HomePage ></HomePage>
    </LayoutBasic>
    </div>
  );
};

export default Home;
